export default function handleInputs(
  root: HTMLElement,
  textCallback: (_e: Event) => void,
  clickInputCallback: (_e: Event) => void,
  clickCalendarCallback: (_e: Event) => void,
  selectInputCallback: (_e: Event) => void,
  booleanToggleCallback: (_e: Event) => void,
) {
  const inputs = Array.from(root.querySelectorAll('input[type="text"]'))
  const clickableContainers = Array.from(
    root.querySelectorAll('[type="clickable"]'),
  )
  const calendars = Array.from(root.querySelectorAll('input[type="date"]'))
  const selects = Array.from(root.querySelectorAll('select'))
  const booleans = Array.from(root.querySelectorAll('input[type="checkbox"]'))

  const nonCalendars = inputs.filter((input: Element) => {
    return !input.classList.contains('js-calendar')
  })

  nonCalendars.forEach((textInput) => {
    textInput.addEventListener('change', (e) => {
      textCallback(e)
    })
  })

  calendars.forEach((calendarInput) => {
    calendarInput.addEventListener('change', (e) => {
      clickCalendarCallback(e)
    })
  })

  clickableContainers.forEach((clickableContainer: Element) => {
    clickableContainer.addEventListener('click', (e) => {
      clickInputCallback(e)
    })
  })

  selects.forEach((select) => {
    select.addEventListener('change', (e) => {
      selectInputCallback(e)
    })
  })

  booleans.forEach((boolean) => {
    boolean.addEventListener('change', (e) => {
      const checkedState = (e.target as HTMLInputElement).hasAttribute(
        'checked',
      )

      if (!checkedState) {
        ;(e.target as HTMLInputElement).removeAttribute('checked')
      } else {
        ;(e.target as HTMLInputElement).setAttribute('checked', 'true')
      }
      booleanToggleCallback(e)
    })
  })
}
